/* eslint-disable func-names */
/* eslint-disable no-undef */
import axios from 'axios';
// import { isConnectedToInternet } from '../utils';
import {CSRF_TOKEN, getPrefData, RESCOUNTRYID, getAuthToken, storePrefData, PREVEOUSURL} from '../storage/preferenceStorage';
import {SOMETHING_WRONG, Types, INTERNET_NOT_CONNECTED} from './request';
import {getDomainURL} from '../utils/helperUtils';
import {COUNTRY_USA} from '../utils/countryCode';
import {setPerformanceConfig} from './perf_config';
import {encrypt, decrypt} from '../utils/appUtils';
import {OTPURL, CONFIRMONETIMEURL, CONFIRMURL, SIGNUPURL, PRERECURRINGURL, CANCELREQUEST} from '../constants/displayConstants';
import {ISENCRYPTION_REQUIRED} from '../utils/domainUrl';
import { Platform } from 'react-native';
const TAG = 'APIREQUEST';

const makeAPICall = async (request, changeRequestId, secret) => {
  // console.log("request",{...request});
  
  let apiUrl = '';
  let prevUrl = '';
  const token = await getAuthToken();
  const csrfToken = await getPrefData(CSRF_TOKEN);
  const resCountryId = await getPrefData(RESCOUNTRYID);
  prevUrl = await getPrefData(PREVEOUSURL);

  apiUrl = getDomainURL(Number(resCountryId));
  const cancelTokenSource = axios.CancelToken.source();

  // const instance = axios.create({ baseURL: apiUrl });
  const instance = axios.create({
    baseURL: `${apiUrl}`,
    withCredentials: false 
  });

  setPerformanceConfig(instance);
  const {type, url, payload, tag, removeEncyption} = request;

  instance.defaults.timeout = 0;

  instance.defaults.headers.post['Content-Type'] = 'application/json';

  let authRequired;
  if (request.authRequired === 'undefined' || request.authRequired === undefined) {
    authRequired = true;
  } else {
    authRequired = request.authRequired;
  }
  if (authRequired) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else if (request.userId) {
    instance.defaults.headers.common['X-Csrf-Token'] = csrfToken;
    instance.defaults.headers.common['User-Id'] = request.userId;
  } else if (request.csrfToken) {
    instance.defaults.headers.common['X-Csrf-Token'] = csrfToken;
  } else {
    delete instance.defaults.headers.common.Authorization;
    delete instance.defaults.headers.common['X-Csrf-Token'];
  }

  let axiosRequest;

  let EncryptedPload;
  // if (Platform.OS === 'web') {
  //   console.log(`-------Request ${tag} ------->`, payload);
  // }
  EncryptedPload = removeEncyption || !ISENCRYPTION_REQUIRED ? payload : encrypt(payload, secret);

  // console.log("EncryptedPload",EncryptedPload);
  

  if (type === Types.GET) {
    axiosRequest = instance.get(url);
  } else if (type === Types.POST) {
    axiosRequest = instance.post(url, EncryptedPload, {
      cancelToken: cancelTokenSource.token
    });
  }
  if (prevUrl === url && (url === OTPURL || url === CONFIRMONETIMEURL || url === CONFIRMURL || url === SIGNUPURL || url === PRERECURRINGURL)) {
    cancelTokenSource.cancel();
  }
  storePrefData(PREVEOUSURL, url);
  return axiosRequest
    .then(response => {
      // console.log("response",response);
      
      // if (Platform.OS === 'web') {
      //   console.log(`-------Encrypted ${tag} ------->`, response);
      // }
      let DecryptedData;
 
      if (!removeEncyption && ISENCRYPTION_REQUIRED) {
        var ENCRYPTED_KEY = changeRequestId(response.data.part2);

        DecryptedData =
          response.config.method !== 'get'
            ? {
                ...response,
                data: decrypt(response.data.part1, ENCRYPTED_KEY)
              }
            : response;
        // if (Platform.OS === 'web') {
          // console.log(`-------Response ${tag} ------->`, DecryptedData);
        // }
        return {tag, data: DecryptedData.data};
      } else {
        return {tag, data: response.data};
      }
    })
    .catch(function(error) {
      if (axios.isCancel(error)) {
        err = {
          code: CANCELREQUEST
        };
        throw err;
      } else {
        if (error.response) {
          let err;
          var ENCRYPTED_KEY = changeRequestId(error.response.data.part2);
          let DecryptedData =
            error.response.config.method !== 'get'
              ? {
                  ...error.response,
                  data: decrypt(error.response.data.part1, ENCRYPTED_KEY)
                }
              : error.response;
          if (error.response.status === 403) {
            let msg;
            if (error.response.data) {
              msg = error.response.data; //JSON.parse(error.response.data);
              msg = msg.message;
            } else {
              msg = error.response.statusText;
            }
            err = {
              code: error.response.status,
              message: msg
            };
          } else {
            err = {
              code: error.response.status,
              message: error.response.statusText
            };
          }

          throw err;
        } else if (error.request) {
          let err;
          if (error.toString() === 'Error: Network Error') {
            err = {
              code: INTERNET_NOT_CONNECTED
            };
          } else {
            err = {
              code: SOMETHING_WRONG
            };
          }

          throw err;
        } else {
          // Something happened in setting up the request that triggered an Error
          const err = {
            code: SOMETHING_WRONG
          };
          throw err;
        }
      }
    });
};

export default makeAPICall;
